module.exports = __webpack_public_path__ + "assets/scoober-logo-desktop-en-671855.svg";